import { Element } from "@craftjs/core";
import { SquareSquareIcon } from "lucide-react";

import BasePreview from "@/components/builder/blocks/base";
import { prop, define } from "@/components/builder/utils";

import { ContainerBlock } from ".";

function SectionPreview({ children, properties: { tagName: Tag, ...properties }, ...props }) {
  children = children || <Element is={ContainerBlock} id="container" />

  return <BasePreview properties={properties} {...props} >
    <Tag className='m-0.5'>
      {children}
    </Tag>
  </BasePreview>
}

export default define('section', SectionPreview)
  .tag({ propTagName: 'tagName' })
  .palete(<SquareSquareIcon size={16} />, 'Section', 'Structures')
  .property(prop.predefined.customClass())
  .property(...prop.predefined.layout())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.container())
  .property(prop.group('Tag', 'tagName').unique()
    .own()
    .category('default')
    .blockClear()
    .options(prop.options()
      .add('div', 'div')
      .add('header', 'header')
      .add('section', 'section')
      .add('main', 'main')
      .add('article', 'article')
      .add('aside', 'aside')
      .add('footer', 'footer')))
  .property(prop.predefined.attributes())
  .defaultProps({
    tagName: 'section',
    layoutType: 'flex',
    flex: { distribute: 'justify-center' },
    size: {
      width: 'w-full',
    },
  })
  .build()
